import * as React from 'react';
import Select from 'react-select';
import { isNull, isArray, isObject, isString } from 'lodash';
import { HelpBlock } from 'react-bootstrap';

export const parseValue = (input) => {
  if (isNull(input)) {
    return '';
  }

  if (isArray(input) && isObject(input[0])) {
    return input.map((item) => item.value);
  }

  return isString(input) || isArray(input) ? input : input.value;
};

export default ({input, options, clearable, className, multi, meta, ...props}) => {
  const onBlur = () => input.onBlur(parseValue(input.value));
  const onChange = (value) => input.onChange(parseValue(value));
  const multiSelect = multi ? multi : false;

  return (
    <div className={meta.touched && meta.error ? 'has-error' : ''}>
      <Select
        value={input.value}
        className={meta.dirty ? className + ' dirty-field' : className}
        onChange={onChange}
        onBlur={onBlur}
        options={options}
        clearable={clearable}
        multi={multiSelect}
      />
      {meta.touched && meta.error && <HelpBlock>{meta.error}</HelpBlock>}
    </div>
  );
};
